export default __webpack_public_path__ + "static/media/to.2cb4df0a.svg";